// api.js

import axios from 'axios';


const instance = axios.create({
  baseURL: 'https://web.g198.cn/api/', // 设置你的API基础URL
  timeout: 5000, // 设置请求超时时间
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 在请求发送之前做一些处理，例如添加token
    // config.headers['Authorization'] = 'Bearer ' + getToken();
    if(localStorage.getItem('token')) {
        config.headers['token'] = localStorage.getItem('token')
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 在响应数据之前做一些处理
    if (response.data.code === 10001) {
      // 需要重新登录了
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      setTimeout(() => {
        window.location.reload();
      }, 500)
    }
    return response.data;
  },
  (error) => {
    // 对响应错误做一些处理
    return Promise.reject(error);
  }
);

export default instance;
